import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Autoplay } from "swiper/modules";

const reviews = [
  {
    name: "Ravi Sharma",
    location: "Kolkata",
    review: "These plastic flower pots are incredibly durable and stylish. I love the variety they offer for my garden!",
    image: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=50&h=50&crop=faces&fit=crop",  },
  {
    name: "Shubham Kumar",
    location: "Kolkata",
    review: "Great quality and lightweight! Perfect for both indoor and outdoor plants. Definitely recommend these pots.",
    image: "https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=50&h=50&crop=faces&fit=crop",  },
  {
    name: "Ankit Kumar",
    location: "Kolkata",
    review: "I was looking for affordable yet elegant flower pots, and these fit the bill perfectly. They're sturdy and easy to move around.",
    image: "https://images.unsplash.com/photo-1544723795-3fb6469f5b39?w=50&h=50&crop=faces&fit=crop",  },
  {
    name: "Sandip Jha",
    location: "Kolkata",
    review: "These plastic flower pots are perfect for my balcony garden. They're easy to clean, and the plants look amazing in them.",
    image: "https://images.unsplash.com/photo-1521119989659-a83eee488004?w=50&h=50&crop=faces&fit=crop",
    },
];

export default function ReviewSection() {
  return (
    <div className="bg-gray-100 text-black py-10">
      <h2 className="text-center font-montserrat md:text-3xl text-2xl font-semibold mb-6">Happy Tales from Happy Gardeners</h2>
      <div className="max-w-6xl  mx-auto px-8">
        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          loop={true}
          autoplay={{ delay: 4000 }}
          pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          modules={[Pagination, Autoplay]}
          className="mySwiper"
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div className="bg-white min-h-[250px] w-[300px] mb-16 text-black p-6 rounded-lg shadow-lg flex flex-col justify-center gap-4">
                <p className="text-lg font-quicksand flex-grow">“{review.review}”</p>
                <div className="flex items-center">
                  <img src={review.image} alt={review.name} className="w-10 h-10 rounded-full object-cover" />
                  <div className="ml-3">
                    <p className="font-bold">{review.name}</p>
                    <p className="text-sm text-gray-500">{review.location}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
